var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('div',{staticClass:"d-flex h-75"},[_c('b-container',{attrs:{"fluid":"","id":"content"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }